import * as angular from "angular";
import {RouteModel} from "../models/route.model";

export class EditDispatchRouteNamePanelService {

  constructor(private $mdPanel) {
  }

  open($event, route: RouteModel, routeName, pickingTimeOffsetInMinutes, cb, onUpdateRouteMetaData?) {
    const panelPosition = this.$mdPanel.newPanelPosition()
    .relativeTo($event.target)
    .addPanelPosition(
      this.$mdPanel.xPosition.CENTER,
      this.$mdPanel.yPosition.BELOW // yPosition.BELOW
    );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
    .openFrom($event)
    .duration(200)
    .withAnimation(this.$mdPanel.animation.FADE);
    // const excludeIdsRef = this.excludeOptions;
    // const ngPlaceholderRef = this.ngPlaceholder;
    // const isOrderedOptionsRef = this.isOrderedOptions;
    // const optionsPrefixRef = this.optionsPrefix;
    // const selectParamsRef = this.selectParams;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<dispatch-edit-route-name-panel ' +
        'type="ctrl.typeRef" ' +
        'route-name="ctrl.routeNameRef" ' +
        'route="ctrl.routeRef" ' +
        'picking-time-offset-in-minutes="ctrl.pickingTimeOffsetInMinutesRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        '</dispatch-edit-route-name-panel>',
      controller: function () {
        this.typeRef = 'custom';
        this.routeNameRef = routeName;
        this.routeRef = route;
        this.pickingTimeOffsetInMinutesRef = pickingTimeOffsetInMinutes;

        // this.ngPlaceholderRef = ngPlaceholderRef;
        //this.excludeIdsRef = excludeIdsRef;
        // this.isOrderedOptionsRef = isOrderedOptionsRef;
        //this.selectParamsRef = selectParamsRef;
        // this.optionsPrefixRef = optionsPrefixRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onChangeRouteName: (panel, updatedRouteName: string) => {
        cb(updatedRouteName, pickingTimeOffsetInMinutes)
        panel.destroy();
      },
      onChangePickingTimeOffsetInMinutes: (panel, updatedPickingTimeOffsetInMinutes?: number) => {
        cb(routeName, updatedPickingTimeOffsetInMinutes)
        panel.destroy();
      },
      onUpdateRouteMetaData: (panel, metaDataPayload) => {
        if (onUpdateRouteMetaData) {
          return onUpdateRouteMetaData(metaDataPayload);
        }
      }
    };

    return this.$mdPanel.open(config);
  }

}

angular
.module('bringoz.admin.commons')
.service('editDispatchRouteNamePanelService', EditDispatchRouteNamePanelService);

